import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"
import {FieldViewSize} from "../../../../../const"
import {EventType} from "../../../../../../gd/const/event"
import FieldDate_Editable from "../../../../../generic/datetime/date/render/editable/editable"
import FieldProto_updateView from "../../../../../proto/render/table/function/update-view"

// const debug = "FieldEventStartEnd_TableCell"
const debug = false

export default function FieldEventStartEnd_TableCell(props: FieldTableCellProps): React.ReactElement {

    const onChange = (value:any) => {

        // if field has tableCellOnValueChange - use it !!!
        if (props.field.fieldParams.tableCellOnValueChange) {
            props.field.fieldParams.tableCellOnValueChange(props.listItem, value, props.manager)
            return
        }

        // Otherwise default = custom field

        // this is for custom fields (!!!)
        // system fields should have their own

        props.listItem.event.setCustomFieldValue(props.field.fieldId, value)
        props.listItem.event.save()

        // need decide how to approach this ...
        // i guess some custom fields can do it (based ion type)
        // some not - it' about aggregation
        props.listItem.updateLastUpdateTime() // otherwise it wont re-render

        FieldProto_updateView(props.manager, props.field)

    }

    let Component
    switch (props.listItem.event.type) {
        case EventType.PROJECT_MILESTONE:
            Component = FieldDate_Editable
            break

        default:
            Component = props.field.renderComponents.editable
    }

    debug && console.log(debug, 'render', props)

    return (
        <div className  = "cell-flex p-h-0"
             style      = {getTableCellStyle(props)}
        >
            <Component
                size        = {FieldViewSize.SMALL}
                className   = "w-100-percent h-100-percent"
                disabled    = {props.manager.isReadOnly}
                field       = {props.field}
                model       = {props.listItem.event}
                onChange    = {props.onChange ? props.onChange : onChange}
                onBlur      = {props.onBlur}
                onFocus     = {props.onFocus}
            />
        </div>
    )
}
